import Slider from './Slider';
import Range from './Range';
import Handle from './Handle';
import createSliderWithTooltip from './createSliderWithTooltip';

Slider.Range = Range;
Slider.Handle = Handle;
Slider.createSliderWithTooltip = createSliderWithTooltip;
export default Slider;
export { Range, Handle, createSliderWithTooltip };


//////////////////
// WEBPACK FOOTER
// ./~/rc-slider/es/index.js
// module id = ./node_modules/rc-slider/es/index.js
// module chunks = 0